import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GetNotificationsResponseDTO } from './notifications.dto';
@Injectable({ providedIn: 'root' })
export class NotificationsService {
  constructor(private http: HttpClient) {}
  getNotifications(
    userId: number,
    lastItemId: number,
    lastOpened: string,
    timezone: string
  ) {
    const url =
      environment.apiUrl +
      '/api/account/notificationhistory/' +
      userId +
      '/' +
      lastItemId +
      '/' +
      lastOpened +
      '?timezone=' +
      timezone;
    return this.http.get<GetNotificationsResponseDTO[]>(url);
  }
}
